var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_53310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.362 172.34C156.249 180.73 172.703 179.539 181.356 169.795C190.007 160.11 189.415 143.457 180.129 134.388C185.031 146.635 199.456 154.128 212.164 150.942C224.871 147.756 234.169 134.3 232.825 121.123C231.48 107.947 219.548 96.8028 206.443 96.3572C217.874 89.9179 223.981 75.1273 220.541 62.4047C217.042 49.6802 204.304 40.1429 191.23 40.5153C178.156 40.8877 165.962 51.0944 163.153 64.0713C173.229 54.9598 174.849 37.8573 166.661 27.0742C158.473 16.2911 141.7 13.2696 130.409 20.7057C119.118 28.1419 114.856 44.746 121.271 56.6943C125.289 43.8753 116.67 28.7589 103.852 24.9965C91.0335 21.2341 76.2831 28.4359 70.3819 40.549C64.4808 52.6621 67.3649 68.1669 76.4503 78.0468C68.3561 67.9089 52.8587 64.7557 41.4402 70.8452C30.0218 76.9347 24.0297 91.7292 27.8845 104.174C31.7392 116.619 44.909 125.354 57.7319 123.864C44.4357 118.86 28.348 128 24.0138 141.626C19.6796 155.251 26.0792 171.051 37.6484 179.264C49.2176 187.478 64.8997 188.595 78.345 184.091C91.7902 179.588 103.154 169.995 111.729 159.14C113.777 166.913 118.849 174.147 126.195 177.373C133.541 180.599 143.081 178.765 147.752 172.271C152.366 165.716 150.134 154.844 146.362 172.34Z",
    fill: "url(#paint0_radial_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5335 134.63C26.0361 136.768 24.8449 139.118 24.0501 141.62C19.7205 155.243 26.1256 171.044 37.6979 179.261C49.2703 187.478 64.953 188.601 78.397 184.102C91.8411 179.604 103.202 170.016 111.773 159.164C113.824 166.937 118.898 174.173 126.246 177.401C133.308 180.505 142.396 178.933 147.236 173.041C157.194 180.697 172.992 179.317 181.405 169.843C187.789 162.696 189.135 151.75 185.665 142.859C192.395 149.841 202.776 153.363 212.207 151.002C224.913 147.82 234.208 134.368 232.858 121.191C231.509 108.015 219.573 96.8672 206.468 96.417C217.896 89.982 223.999 75.1942 220.554 62.4709C217.051 49.7457 204.309 40.2044 191.235 40.5722C189.298 40.6267 187.381 40.8969 185.511 41.3599C185.605 52.7253 179.979 64.2858 170.25 70.1255C163.159 74.3821 154.467 75.335 146.458 73.4432C151.046 80.0275 153.298 88.3609 151.913 96.3278C149.184 112.015 133.942 124.057 118.155 124.063C103.142 124.069 89.0486 113.968 82.8551 100.182C87.8803 113.805 82.9933 130.672 71.282 139.265C58.9428 148.318 40.2942 147.024 29.2409 136.41C28.6464 135.839 28.0771 135.245 27.5335 134.63Z",
    fill: "url(#paint1_linear_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.369 142.851C105.579 155.774 104.34 169.433 104.051 182.753C103.761 196.072 105.876 212.437 112.729 223.756C119.581 235.075 134.174 242.463 146.074 236.964C153.489 233.532 158.474 225.931 160.768 217.912C163.062 209.893 161.829 199.157 161.831 190.805C161.74 171.312 161.648 151.819 161.618 132.272C161.105 130.497 160.596 128.664 160.025 126.885C155.142 127.185 150.313 127.547 145.431 127.848C147.959 131.444 144.995 137.445 140.651 137.493C136.307 137.541 133.244 131.645 135.698 127.987C131.198 128.604 126.699 129.221 122.2 129.838C125.775 132.521 123.952 139.587 119.519 140.092C115.138 140.66 111.762 134.279 113.589 129.649C109.469 130.64 105.348 131.631 101.241 133.262C102.248 137.101 103.201 140.878 102.369 142.851Z",
    fill: "url(#paint2_linear_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.608 130.834C109.982 139.74 109.669 148.912 109.359 158.015C109.279 160.36 109.199 162.7 109.148 165.03C108.858 178.35 110.971 194.716 117.822 206.034C124.673 217.353 139.263 224.74 151.162 219.24C155.681 217.149 159.297 213.508 161.952 209.169C161.794 212.249 161.421 215.216 160.658 217.882C158.364 225.902 153.379 233.503 145.964 236.935C134.065 242.436 119.475 235.049 112.624 223.73C105.773 212.411 103.659 196.045 103.95 182.726C104.001 180.396 104.08 178.055 104.16 175.71C104.538 164.649 104.919 153.485 102.271 142.822C103.103 140.85 102.15 137.072 101.144 133.233C103.628 132.247 106.117 131.494 108.608 130.834Z",
    fill: "url(#paint3_linear_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.654 152.912C123.896 156.35 122.541 159.252 120.626 159.366C118.718 159.502 116.997 156.823 116.755 153.385C116.513 149.946 117.868 147.044 119.783 146.93C121.686 146.773 123.412 149.473 123.654 152.912Z",
    fill: "url(#paint4_radial_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.142 152.007C152.384 155.446 151.029 158.348 149.115 158.462C147.206 158.598 145.485 155.919 145.243 152.48C145.002 149.041 146.357 146.14 148.271 146.026C150.174 145.868 151.9 148.569 152.142 152.007Z",
    fill: "url(#paint5_radial_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.808 154.195C140.413 154.178 141.389 155.945 140.506 157.285C139.534 158.787 137.846 159.779 135.92 159.815C133.995 159.852 132.294 158.9 131.265 157.42C130.344 156.1 131.271 154.312 132.879 154.276C132.879 154.276 135.084 154.648 135.82 154.627C136.571 154.629 138.808 154.195 138.808 154.195Z",
    fill: "#067044"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.187 158.698C138.277 159.382 137.147 159.792 135.92 159.815C134.027 159.851 132.351 158.931 131.316 157.494C132.226 156.811 133.356 156.4 134.583 156.377C136.476 156.342 138.153 157.261 139.187 158.698Z",
    fill: "#9DE099",
    fillOpacity: 0.46
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.617,
    cy: 76.5239,
    rx: 19.4349,
    ry: 19.4605,
    fill: "#4FBE42"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.776,
    cy: 66.3576,
    rx: 22.6257,
    ry: 22.6555,
    fill: "url(#paint6_radial_336_53310)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 113.159,
    cy: 82.6235,
    rx: 41.1904,
    ry: 41.2445,
    fill: "url(#paint7_radial_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.608 73.9102C152.449 96.5527 134.069 114.859 111.419 114.859C92.803 114.859 77.0714 102.493 71.9698 85.5173C71.9691 85.6158 71.9688 85.7145 71.9688 85.8132C71.9688 108.592 90.4103 127.058 113.159 127.058C135.908 127.058 154.349 108.592 154.349 85.8132C154.349 81.6749 153.741 77.6789 152.608 73.9102Z",
    fill: "url(#paint8_linear_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.706 138.076C162.671 139.035 159.441 139.553 156.089 139.553C144.339 139.553 134.072 133.192 128.534 123.722L139.742 122.19C137.288 125.847 140.355 131.743 144.701 131.696C149.047 131.65 152.011 125.651 149.48 122.055C151.923 121.905 154.352 121.74 156.781 121.576C159.21 121.411 161.639 121.246 164.082 121.097C164.533 122.501 164.946 123.939 165.352 125.355C165.461 125.733 165.569 126.11 165.677 126.484C165.685 130.35 165.694 134.214 165.706 138.076Z",
    fill: "#35A328",
    fillOpacity: 0.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.09,
    cy: 102.375,
    rx: 31.908,
    ry: 31.95,
    fill: "url(#paint9_radial_336_53310)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.449 120.964C169.071 120.964 183.357 106.66 183.357 89.014C183.357 87.8107 183.291 86.6229 183.161 85.4541C186.226 90.3607 187.998 96.1606 187.998 102.375C187.998 120.02 173.712 134.325 156.09 134.325C139.67 134.325 126.146 121.905 124.378 105.935C130.017 114.961 140.033 120.964 151.449 120.964Z",
    fill: "url(#paint10_linear_336_53310)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_53310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5018 42.8335) rotate(33.1651) scale(187.405 227.607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60C454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_53310",
    x1: 201.317,
    y1: 170.044,
    x2: 21.5778,
    y2: 76.5811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38A72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#2F9822"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD56F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_336_53310",
    x1: 131.114,
    y1: 265.333,
    x2: 167.743,
    y2: 118.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDEBB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564058,
    stopColor: "#A4EF9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91699,
    stopColor: "#7FD471"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_336_53310",
    x1: 163.878,
    y1: 319.351,
    x2: 114.39,
    y2: 106.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386392,
    stopColor: "#A2E29E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59C541"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_336_53310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.204 153.142) rotate(-3.91131) scale(5.04108 5.04489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#077145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05663E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_336_53310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.693 152.238) rotate(-3.91131) scale(5.04108 5.04489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2083,
    stopColor: "#077145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05663E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_336_53310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(170.303 47.7685) rotate(67.4394) scale(39.3155 39.279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5ACA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A126"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_336_53310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.5717 55.3207) rotate(40.9064) scale(74.0746 74.0885)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64D356"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51C143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_53310",
    x1: 56.885,
    y1: 58.5113,
    x2: 128.645,
    y2: 146.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68D55A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35A328"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_336_53310",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174.944 130.258) rotate(-110.956) scale(64.0718 64.0092)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3FB830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61D154"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_53310",
    x1: 187.998,
    y1: 91.3374,
    x2: 92.716,
    y2: 196.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#81E275"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_53310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading1);
export default __webpack_public_path__ + "static/media/loading_1.ec7846bd1effb1d6ce996f5dff3b063b.svg";
export { ForwardRef as ReactComponent };